import { configureStore } from '@reduxjs/toolkit';
import  userReducer  from "./feature/user";
import  adminUserReducer  from "./feature/adminuser";
import jobReducer  from "./feature/jobs"

const store = configureStore({
  reducer: {
    user: userReducer,
    adminUser: adminUserReducer,
    job: jobReducer
  },
});

export default store;
